export { default as Slider, } from './components/Slider';
export { default as MultiSlider, } from './components/MultiSlider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/preact-range-slider/es5-esm/index.js
// module id = dTZL
// module chunks = 10